__turbopack_context__.v({
  "eyebrow": "OrmServicesCardSection-module__3FgOFq__eyebrow",
  "heading": "OrmServicesCardSection-module__3FgOFq__heading",
  "section": "OrmServicesCardSection-module__3FgOFq__section",
  "title": "OrmServicesCardSection-module__3FgOFq__title",
});
